import { render, staticRenderFns } from "./cp_businessMenu.vue?vue&type=template&id=1f70f982&scoped=true"
import script from "./cp_businessMenu.vue?vue&type=script&lang=js"
export * from "./cp_businessMenu.vue?vue&type=script&lang=js"
import style0 from "./cp_businessMenu.vue?vue&type=style&index=0&id=1f70f982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70f982",
  null
  
)

export default component.exports